import { Tooltip } from '@ipfabric/ui-components/Tooltip/Tooltip';
import {
  type PathLookupEventTopic,
  pathLookupEventTopics,
} from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import { useGraphContextSelectors } from 'components/Graph/GraphContext';
import { togglePathLookupEventTopic } from 'components/Graph/commands/pathLookup/togglePathLookupEventTopic';
import { useLocale } from 'containers/App/LocaleContext';
import { memo } from 'react';

const BarePathLookupNodeColors = () => {
  const msgPathLookup = useLocale().canvasGraph.graphSidePanel.pathlookup;
  const ctxProps = useGraphContextSelectors({
    dispatch: prop('dispatch'),
    ignoredTopics: prop(
      'pathlookup',
      'presetDraft',
      'pathLookup',
      'ignoredTopics',
    ),
  });

  const renderTopicSummary = (topic: PathLookupEventTopic) => (
    <label
      className='py-lgu-2 my-lgu-2 flex cursor-pointer flex-row'
      key={topic}
    >
      <span className='flex-1'>
        {msgPathLookup.pathLookupEventTopics[topic]}
      </span>
      <input
        type='checkbox'
        checked={!ctxProps.ignoredTopics.includes(topic)}
        onChange={() => {
          ctxProps.dispatch(togglePathLookupEventTopic, { topic });
        }}
      />
    </label>
  );

  return (
    <div className='px py-8'>
      <p className='m-0 pb-5 font-bold'>
        {msgPathLookup.setupTopics.title}
        <Tooltip content={msgPathLookup.setupTopics.titleHelp}>
          <i className='fa fa-question-circle fa-fw ml-lgu-2' />
        </Tooltip>
      </p>
      {pathLookupEventTopics.map(renderTopicSummary)}
    </div>
  );
};

export const PathLookupNodeColors = memo(BarePathLookupNodeColors);
